import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite/no-important';

import StyleUtils from './StyleUtils';

class PositionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRedirect: false,
    };
    this.onCardClick = this.onCardClick.bind(this);
  }

  onCardClick() {
    this.setState({
      shouldRedirect: true,
    });
  }

  render() {
    const content = this.props.positionContent;
    const { sectionContent } = this.props;

    if (this.state.shouldRedirect) {
      return (
        <Redirect push to={`/${sectionContent.route}/${content.route}`} />
      );
    }

    const sectionLabel = (
      <p className={css(styles.sectionLabel)}>
        {sectionContent.name}
      </p>
    );

    return (
      <Link
        to={`/${sectionContent.route}/${content.route}`}
        className={css(styles.positionCard)}
      >
        <h3 className={css(styles.positionName)}>
          {content.name}
        </h3>
        {sectionContent.name && sectionLabel}
      </Link>
    );
  }
}

const styles = StyleSheet.create({
  positionCard: {
    padding: '4px 10px',
    marginRight: '3.6%',
    marginLeft: '3.6%',
    marginTop: 25,
    display: 'inline-block',
    textDecoration: 'none',
    color: 'grey',
    borderRadius: 0,
    width: 'calc(25% - 10px)',
    boxShadow: '0px 0px 4px rgba(0,0,0,0.15), 0px 0px 4px rgba(0,0,0,0.15)',
    transition: StyleUtils.fastTransition,
    ':hover': {
      color: StyleUtils.buttonBlue,
      cursor: 'pointer',
      transform: 'translate3d(0px,-5px,0px)',
    },
    '@media (max-width: 535px)': {
      width: 'calc(75% - 20px)', // subtract off padding
      marginLeft: '12.5%',
      marginRight: '12.5%',
      marginTop: 20,
    },
    '@media (min-width: 536px) and (max-width: 880px)': {
      width: 'calc(46% - 20px)',
      marginLeft: '2%',
      marginRight: '2%',
    },
  },
  positionName: {
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontSize: 18,
    margin: '5px 0px',
  },
  sectionLabel: {
    textTransform: 'uppercase',
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontSize: 14,
    margin: '0px 0px 5px 0px',
  },
});

export default PositionCard;



// WEBPACK FOOTER //
// ./src/components/PositionCard.jsx